import { useContext } from "react";
import { clearToken, getUserData } from "./userFunctions";
import { UserContext } from "./userContext";

const useUser = () => {
    const usuario = useContext(UserContext);

    async function carregarUsuario() {
        let resp = await getUserData();
        if (resp.error === false) {
            usuario?.setUser(resp.data);
        }
    }

    const getUser = () => {
        let usr = usuario?.user;
        if (usr === null || usr === undefined)
            carregarUsuario();
        else
            return usuario?.user;
    }

    const clear = () => {
        clearToken();
        localStorage.clear();
        usuario?.setUser(null);
    }

    return { user: usuario?.user, clear, getUser }
}

export default useUser;
